<template>
  <v-row justify="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar :color="getCategoryColor(myTemplate)" height="60" dark class="elevation-0">
        <v-toolbar-title>{{ myTemplate.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card>
        <v-card-text class="pa-1 overflow-y-auto" :style="dialogHeight">
          <v-container>
            <v-row align="center">
              <v-col cols="5" class="py-0">
                <v-select
                  ref="category"
                  :items="$DESCRIPTIONS_ITEMS"
                  label="*分類"
                  v-model.number="myTemplate.category"
                  item-text="name"
                  item-value="key"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="4" class="py-0">
                <v-select
                  ref="month"
                  :items="$MONTHS4_TABLE"
                  label="*月"
                  v-model="myTemplate.month"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="5" class="py-0">
                <v-select
                  ref="week"
                  :items="$WEEK_TABLE"
                  label="*週"
                  v-model="myTemplate.week"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="value"
                  :disabled="event == 'event'"
                ></v-select>
              </v-col>
              <v-col cols="4" class="py-0">
                <v-text-field
                  ref="period"
                  v-model.number="myTemplate.period"
                  :rules="[rules.required, rules.num]"
                  label="*期間(日)"
                  :disabled="event == 'event'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-select
                  v-if="event == 'event'"
                  ref="title"
                  :items="filteredEvents"
                  label="*項目"
                  v-model="myTemplate.key"
                  :rules="[rules.required]"
                  item-text="title"
                  item-value="key"
                  @change="onChangeTemplate()"
                >
                </v-select>
                <v-text-field
                  v-else
                  ref="title"
                  v-model="myTemplate.title"
                  :rules="[rules.required]"
                  label="*項目"
                  :disabled="event == 'event'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-textarea
                  prepend-inner-icon="mdi-pencil-box"
                  name="description"
                  label="説明"
                  v-model="myTemplate.description"
                  outlined
                  hide-details
                  :disabled="event == 'event'"
                  rows="4"
                >
                </v-textarea>
              </v-col>
              <v-col v-if="event == 'event'" cols="6" class="pb-0">
                <template-date-picker
                  :id="3"
                  :icon="'event'"
                  :date="myItem.startDate"
                  :label="'開始日'"
                  :title="false"
                  @updated="onUpdated"
                ></template-date-picker>
              </v-col>
              <v-col v-if="event == 'event'" cols="6" class="pb-0">
                <template-date-picker
                  :id="4"
                  :icon="'event'"
                  :date="myItem.endDate"
                  :label="'終了日'"
                  :title="false"
                  @updated="onUpdated"
                  :validate="validate"
                ></template-date-picker>
              </v-col>
              <v-col v-if="event == 'event'" cols="12" class="py-0">
                <v-select
                  ref="charge"
                  prepend-icon="mdi-account-circle-outline"
                  :items="scopes"
                  label="範囲"
                  v-model="myScope"
                  dense
                  auto-grow
                  multiple
                  item-text="name"
                  item-value="key"
                  class="caption"
                  small-chips
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click="close()">取消</v-btn>
          <v-btn rounded depressed color="primary" @click.native="onSubmit()">{{ getButtonLable() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
export default {
  data () {
    return {
      startDate: false,
      endDate: false,
      submit: false,
      loading: false,
      scopes: [],
      myScope: null,
      myItem: null,
      myTemplate: null,
      validate: false,
      rules: {
        required: value => !!value || '必須',
        diffDate: value => {
          var ds = new Date(this.myItem.startDate)
          var de = new Date(this.myItem.endDate)
          return ds.getTime() <= de.getTime() || '日付が無効です'
        },
        num: value => {
          const pattern = /^[1-9]|[1-9][0-9]$/
          return pattern.test(value) || '無効な値です（半角数字を指定）'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      chatRefStatus: 'chatRefStatus/chatRef',
      windowSize: 'shared/windowSize'
    }),
    form () {
      return {
        category: this.myTemplate.category,
        title: this.myTemplate.title,
        month: this.myTemplate.month,
        week: this.myTemplate.week
      }
    },
    filteredEvents () {
      var temp = []
      for (var i in this.templateEvents) {
        if (this.myTemplate.category === this.templateEvents[i].category && (this.myTemplate.month === this.templateEvents[i].month)) {
          temp.push(JSON.parse(JSON.stringify(this.templateEvents[i])))
        }
      }
      return temp
    },
    dialogHeight () {
      var h = Math.round(this.windowSize.y * 0.6)
      h = h > 700 ? 700 : h
      return 'max-height: ' + String(h) + 'px; overflow-x: hidden;'
    }
  },
  props: [ 'item', 'dialog', 'event' ],
  watch: {
    myScope () {
      if (this.myScope.indexOf('*') !== -1) {
        for (var i in this.scopes) {
          if (this.scopes[i].key !== '*') {
            this.scopes[i].disabled = true
          }
        }
      } else {
        for (i in this.scopes) {
          if (this.scopes[i].key !== '*') {
            this.scopes[i].disabled = false
          } else {
            if (this.myScope.length !== 0) {
              this.scopes[i].disabled = true
            } else {
              this.scopes[i].disabled = false
            }
          }
        }
      }
    }
  },
  created () {
    if (this.event === 'event') {
      this.myItem = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
      var item = JSON.parse(JSON.stringify(this.item))
      var keys = Object.keys(this.myItem)
      for (var i in keys) {
        this.myItem[keys[i]] = item[keys[i]]
      }
      this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateEvents/initial']))
      var index = this.templateEvents.findIndex(event => event.key === this.item.template)
      if (index !== -1) {
        this.myTemplate = JSON.parse(JSON.stringify(this.templateEvents[index]))
      }
    } else {
      this.myItem = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
      this.myTemplate = JSON.parse(JSON.stringify(this.item))
    }
    this.createScopes()
    keys = Object.keys(this.data.schools)
    for (i in keys) {
      if (this.data.schools[keys[i]]) {
        index = this.schools.findIndex(school => school.key === keys[i])
        if (index !== -1) {
          this.school = this.schools[index]
        }
      }
    }
  },
  methods: {
    createScopes () {
      this.scopes = [
        { type: 'group',
          name: '共通',
          key: '*',
          item: null,
          disabled: false
        }
      ]
      this.myScope = []
      if (!this.data) {
        return
      }
      if (this.data.order) {
        for (var i in this.data.order) {
          var index = this.groups.findIndex(group => group.key === this.data.order[i])
          if (index !== -1) {
            if (this.groups[index].enable && this.groups[index].classroom) {
              this.scopes.push({
                type: 'group',
                name: this.groups[index].name,
                key: this.groups[index].key,
                item: this.groups[index],
                disabled: false
              })
            }
          }
        }
      } else {
        var keys = Object.keys(this.data.groups)
        for (i in keys) {
          if (this.data.groups[keys[i]]) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.scopes.push({
                  type: 'group',
                  name: this.groups[index].name,
                  key: this.groups[index].key,
                  item: this.groups[index],
                  disabled: false
                })
              }
            }
          }
        }
      }
      index = this.chatRefStatus.findIndex(c => c.key === this.data.key)
      if (index !== -1) {
        keys = Object.keys(this.chatRefStatus[index].members)
        for (i in keys) {
          index = this.groups.findIndex(g => g.key === keys[i])
          if (index !== -1) {
            if (this.groups[index].enable && !this.groups[index].classroom && this.groups[index].task) {
              this.scopes.push({
                type: 'group',
                name: this.groups[index].name,
                key: this.groups[index].key,
                item: this.groups[index],
                disabled: false
              })
            }
          }
        }
      }
      keys = Object.keys(this.myItem.groups)
      for (i in keys) {
        this.myScope.push(keys[i])
      }
    },
    getButtonLable () {
      if (this.event === 'event') {
        return this.myItem.key ? '更新' : '追加'
      } else {
        return this.myTemplate.key ? '更新' : '追加'
      }
    },
    onChangeTemplate () {
      var index = this.templateEvents.findIndex(t => t.key === this.myTemplate.key)
      if (index !== -1) {
        this.myTemplate = JSON.parse(JSON.stringify(this.templateEvents[index]))
        this.myItem.template = this.myTemplate.key
        moment.tz.setDefault('Asia/Tokyo')
        var start = moment(this.myItem.startDate)
        var end = start.add(this.myTemplate.period - 1, 'days')
        this.myItem.endDate = end.format('YYYY-MM-DD')
      } else {
        this.myTemplate = JSON.parse(JSON.stringify(this.$store.getters['templateEvents/initial']))
      }
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 3:
          this.myItem.startDate = value.date
          break
        case 4:
          this.myItem.endDate = value.date
          break
      }
    },
    onSubmit () {
      var vm = this
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.formHasErrors = true
        }
        this.$refs[f].validate(true)
      })
      if (this.event === 'event') {
        if (this.myItem.startDate && this.myItem.endDate) {
          var diff = moment(this.myItem.endDate, 'YYYY-MM-DD').diff(moment(this.myItem.startDate, 'YYYY-MM-DD'), 'days')
          if (diff < 0) {
            this.myItem.endDate = this.myItem.startDate
            this.myItem.end = this.myItem.start
            this.formHasErrors = true
          }
        } else {
          this.formHasErrors = true
          this.validate = true
        }
      }
      if (this.formHasErrors) {
        return
      }
      vm.loading = true
      this.$nextTick(function () {
        var payload = null
        var path = 'templateEvents/write'
        if (this.event === 'event') {
          payload = JSON.parse(JSON.stringify(this.myItem))
          path = 'scheduleEvents/write'
          var start = moment(payload.startDate)
          var end = moment(payload.endDate)
          var period = end.diff(start, 'days')
          moment.tz.setDefault('Asia/Tokyo')
          payload.start = {
            date: start.format('YYYY-MM-DD'),
            yyyy: parseInt(start.format('YYYY')),
            mm: parseInt(start.format('MM')),
            dd: parseInt(start.format('DD'))
          }
          payload.end = {
            date: end.format('YYYY-MM-DD'),
            yyyy: parseInt(end.format('YYYY')),
            mm: parseInt(end.format('MM')),
            dd: parseInt(end.format('DD'))
          }
          payload.duration = period + 1
          var groups = {}
          for (var i in this.myScope) {
            groups[this.myScope[i]] = true
          }
          payload.groups = groups
        } else {
          payload = JSON.parse(JSON.stringify(this.myTemplate))
        }
        payload.schools[this.school.key] = true
        if (!payload.key) {
          payload.createdAt = parseInt(new Date().getTime())
        }
        payload.updatedAt = parseInt(new Date().getTime())
        vm.$store.dispatch(path, JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
          this.close()
        })
      })
    },
    close () {
      this.$emit('dismissed', null)
    }
  }
}
</script>
